<b3-modal
  [open]="open"
  overlay
  size="md"
  (b3-close)="onModalDismiss()">
  <b3-modal-header
    [heading]="heading"
    aria-level="2"
    icon="info"
    icon-tone="info"
    close-aria-label="Fechar">
  </b3-modal-header>

  <b3-modal-body>
    <p class="foreign-entity-modal__text">{{ bodyText }}</p>
  </b3-modal-body>

  <b3-modal-footer>
    <div class="foreign-entity-modal__footer">
      <b3-button
        type="button"
        variant="outlined"
        tone="default"
        (b3-click)="onCancel()">
        Não, cancelar
      </b3-button>
      <b3-button
        type="button"
        variant="filled"
        tone="default"
        (b3-click)="onConfirm()">
        Sim, confirmar
      </b3-button>
    </div>
  </b3-modal-footer>
</b3-modal>
